import fetcher from 'api/fetcher';
import { NotificationName } from 'utils/constants/notification';

import { addNotification } from 'store/models/notification';

export default (crmActivityTypeId, checked, setChecked, setDisabled) => {
    const newCheckedValue = !checked;
    return (dispatch) => {
        setDisabled(true);
        return fetcher
            .put(`/api/v1/crm/activity/${crmActivityTypeId}?enabled=${newCheckedValue}`)
            .then(() => {
                setChecked(newCheckedValue);
                dispatch(addNotification(NotificationName.CrmUpdateSuccess));
            })
            .catch(() => {
                dispatch(addNotification(NotificationName.CrmUpdateError));
            })
            .finally(() => {
                setDisabled(false);
            });
    };
};
